export default {"src":"/_next/static/media/elevation-bg.37318f42.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};